import { render } from "./DivisionPlanTabsComponent.vue?vue&type=template&id=0ed8448c"
import script from "./DivisionPlanTabsComponent.vue?vue&type=script&lang=js"
export * from "./DivisionPlanTabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__